import styled from 'styled-components';
import { AppIcon } from 'modules/mobileApps/components/AppIcon';
import { colors } from 'ui/theme';
import { Destination } from '../types';

const InAppRow = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`;
const DestinationPlatform = styled.span`
  padding-right: 1rem;
`;
const DestinationName = styled.span``;
const DestinationValue = styled.span`
  justify-self: end;
  padding-left: 1rem;
`;
const Flex = styled.div`
  display: inline-flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const InAppTooltipBreakdown = ({
  destination,
  total,
  numberType,
}: {
  destination: Omit<Destination, 'color' | 'percentage'>;
  total: number;
  numberType?: string;
}) => {
  return (
    <InAppRow data-test={`in-app-tooltip-breakdown-row`}>
      {destination?.platform && (
        <DestinationPlatform>
          <AppIcon platformType={destination?.platform} width={16} color={colors.white} />
        </DestinationPlatform>
      )}
      <Flex>
        <DestinationName>{destination?.appName}</DestinationName>
        <DestinationValue>
          {numberType === 'percentage'
            ? `${(destination?.value * 100).toFixed(2)}%`
            : `${destination?.value?.toLocaleString()} (${(
                (total === 0 ? 0 : destination?.value / total) * 100
              ).toFixed(2)}%)`}
        </DestinationValue>
      </Flex>
    </InAppRow>
  );
};
